/**
 * The little confirmation toasts in the bottom-left corner ("Dato gemt",
 * "Success", …) are opt-out per user. Frederiksberg VUC asked for the switch
 * in August 2026: a teacher who saves a lot of dates in a row does not need to
 * be told about each one.
 *
 * Three surfaces spawn them, and all three consult this module:
 *   - `generalStore/showToast` → LearnUToast.vue
 *   - `spawnSuccessToast` in utils/globals.js → $snotify / vue-toastification
 *   - the `$snotify.success` / `$snotify.info` shims in
 *     plugins/snotifyAdapter.js, which is where the realtime event toasts in
 *     dialogue.vue ("A student submitted an assignment") come from. Those were
 *     missed in the first pass — nothing passes a position, so they inherit
 *     vue-toastification's BOTTOM_LEFT default and land in the very corner the
 *     setting is named after.
 *
 * Only the "that worked" / "this happened" class is suppressed. Errors and
 * warnings always show: a silently swallowed failure is a support ticket, an
 * unwanted toast is not.
 */

export const UI_TOASTS_SETTING = 'show_ui_toasts'

// Opt-out, like `allow_olly`: the row only exists once a user has turned the
// toasts off, so anything other than a stored '0' means "show them".
export function uiToastsEnabled(userSettings) {
    return String((userSettings || {})[UI_TOASTS_SETTING]) !== '0'
}

// `error` and `warning` explain why something did not happen — they are not
// confirmations, and the setting does not cover them.
export function isSuppressableToastType(type) {
    return !type || type === 'info'
}
